/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/deal-partner.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: DEAL PARTNER TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms/deal-partner', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms/deal-partner']
  }
}), ...{ filepath: "/app/client/pages/terms/deal-partner.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_deal_partner" } }, null, ({}) => {
  const placeholderClassName = 'font-bold text-slate-900';
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-[920px] mx-auto">
                <div className="mb-6">
                    <TermsTabs current="dealPartner" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-6">
                        Deal Partner Agreement
                    </h1>

                    <div className="prose prose-slate max-w-none">
                        <header className="mb-6">
                            <p className="text-slate-700 mb-0">
                                This Deal Partner Agreement (hereinafter referred to as the “Agreement”) is entered into
                                as of <span className={placeholderClassName}>[DATE]</span>, between:
                            </p>
                        </header>

                        <section className="not-prose border border-slate-200 rounded-xl p-4 bg-slate-50 mb-8" aria-label="Parties">
                            <dl className="text-slate-800">
                                <dt className="font-bold mt-0">Cross Path Network Ltd</dt>
                                <dd className="ml-0 mt-1">Registered in England with registration number 13863925</dd>
                                <dd className="ml-0 mt-1">
                                    Address: Unit 01.12, 1st Floor, 30 Norman Road, London, SE10 9QX, United Kingdom
                                </dd>
                                <dd className="ml-0 mt-1">(“Cross Path” or the “Company”)</dd>

                                <dt className="font-bold mt-4">Deal Partner</dt>
                                <dd className="ml-0 mt-1">
                                    Name of the Deal Partner: <span className={placeholderClassName}>[NAME]</span>
                                </dd>
                                <dd className="ml-0 mt-1">
                                    Address of the Deal Partner: <span className={placeholderClassName}>[ADDRESS]</span>
                                </dd>
                                <dd className="ml-0 mt-1">(“Deal Partner”)</dd>
                            </dl>
                            <p className="text-slate-600 mt-3 mb-0">Collectively referred to as “the Parties”.</p>
                        </section>

                        <section className="mt-0">
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                1. Purpose of the Agreement
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The purpose of this Agreement is to define the terms and conditions under which the Deal
                                Partner introduces potential clients to Cross Path.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                1A. Definitions
                            </h2>
                            <p className="text-slate-700 mb-4">For the purposes of this Agreement:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    <strong>Lead:</strong> A potential business opportunity introduced by the Deal
                                    Partner to Cross Path, which includes one or more contact persons at a client
                                    company who may be interested in Cross Path&apos;s services.
                                </li>
                                <li>
                                    <strong>Contact Person:</strong> An individual at a client company whom the Deal
                                    Partner directly introduces to Cross Path. Exclusivity rules (see Section 3) apply
                                    at the level of contact persons, not companies.
                                </li>
                                <li>
                                    <strong>Referring Party:</strong> The party who invited the Deal Partner to join
                                    Cross Path&apos;s network. This can be:
                                    <ul className="list-disc pl-6 mt-2">
                                        <li>Cross Path directly, or</li>
                                        <li>A Business Partner (independent person, affiliated to Cross Path), or</li>
                                        <li>A Team Leader (independent person, affiliated to Cross Path)</li>
                                    </ul>
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                2. Nature of the Collaboration
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The relationship established by this Agreement is that of independent contractors.
                                Nothing in this Agreement shall be construed to create a relationship of employer and
                                employee, principal and agent, or joint venture between the Parties.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                3. Responsibilities of the Deal Partner
                            </h2>
                            <p className="text-slate-700 mb-4">The Deal Partner agrees to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Identify and introduce potential clients to Cross Path who may require Cross
                                    Path&apos;s services.
                                </li>
                                <li>
                                    Make reasonable efforts to facilitate communication between Cross Path and the
                                    introduced clients, including attending introductory meetings when necessary and
                                    providing relevant background information about the client&apos;s needs.
                                </li>
                                <li>
                                    Declare all leads in the CRM platform provided by Cross Path or send those
                                    information to the appropriate contact person.
                                </li>
                                <li>Comply with all applicable anti-bribery and anti-corruption laws.</li>
                                <li>
                                    Not make any commitments, statements, or representations on behalf of Cross Path
                                    without prior written approval.
                                </li>
                                <li>
                                    Not engage directly with any clients, candidates, or personnel from the Cross Path
                                    platform without prior written approval from Cross Path.
                                </li>
                            </ul>

                            <p className="text-slate-700 mb-4">
                                The Deal Partner acknowledges that any leads or contact persons they introduce are
                                exclusive to them. Cross Path will not count such leads as introduced by other deal
                                partners unless expressly agreed in writing.
                            </p>
                            <p className="text-slate-700 mb-0">
                                For avoidance of doubt, exclusivity applies to contact persons, not companies; different
                                deal partners may introduce different contact persons from the same company.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                4. Responsibilities of Cross Path
                            </h2>
                            <p className="text-slate-700 mb-4">Cross Path agrees to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Provide the Deal Partner with free, restricted access to the CRM platform for the
                                    sole purpose of:
                                    <ul className="list-disc pl-6 mt-2">
                                        <li>Declaring new leads</li>
                                        <li>Tracking the progress of their introduced leads</li>
                                        <li>
                                            Viewing commission statements and generating invoices for earned commissions
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    Inform the Deal Partner about the progress of any leads or contact persons
                                    introduced by the Deal Partner.
                                </li>
                                <li>
                                    Notify the Deal Partner in writing if another deal partner has previously introduced
                                    the same contact person. In such a case, Cross Path will attribute the lead to the
                                    first-introducing deal partner unless the original introducer is no longer actively
                                    managing the lead or in other exceptional circumstances.
                                </li>
                                <li>
                                    Be responsible for signing, invoicing, and collecting payments from the client
                                    company. If, for exceptional reasons, Cross Path cannot be the signing party, it
                                    must at least be the invoicing party. Otherwise, the corresponding recruitment
                                    missions will not count as valid for commission purposes.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                5. Commission and Payment Terms
                            </h2>
                            <p className="text-slate-700 mb-2">
                                5.1 The Deal Partner&apos;s commission rate and amount for each recruitment mandate
                                shall be as displayed on the Cross Path platform for that specific mandate. The
                                commission structure may vary from one deal to another and is determined by the
                                Referring Party (as defined in Section 1A) or by Cross Path directly.
                            </p>
                            <p className="text-slate-700 mb-2">
                                5.2 The Deal Partner agrees to refer to the platform for accurate, up-to-date commission
                                information for each of their active leads and mandates.
                            </p>
                            <p className="text-slate-700 mb-2">
                                5.3 Commission payments will be made only after Cross Path has received the full amount
                                due from the client, and provided no portion of that amount is subject to refund or
                                reimbursement.
                            </p>
                            <p className="text-slate-700 mb-2">
                                5.4 The Deal Partner acknowledges that no commission shall be payable for any
                                introduction that does not result in a successful paid placement.
                            </p>
                            <p className="text-slate-700 mb-2">
                                5.5 The Deal Partner will only be eligible for commission on leads or contact persons
                                that Cross Path recognizes as introduced by them under the exclusivity rules outlined in
                                Section 3.
                            </p>
                            <p className="text-slate-700 mb-2">
                                5.6 The Deal Partner shall be credited for all recruitment mandates successfully closed
                                following the initial introduction of the client by the Deal Partner, without any time
                                limitation, provided that this Agreement has not been terminated.
                            </p>
                            <p className="text-slate-700 mb-0">
                                5.7 The Deal Partner will generate their own invoices for earned commissions using the
                                platform&apos;s invoicing tools, based on the commission amounts displayed on the
                                platform.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                6. Platform Access
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The Deal Partner shall have free, restricted access to Cross Path&apos;s CRM platform.
                                This access includes:
                            </p>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>Lead declaration functionality</li>
                                <li>View-only access to the status and progress of their own introduced leads</li>
                                <li>Commission tracking and invoice generation tools</li>
                            </ul>
                            <p className="text-slate-700 mb-4">The Deal Partner shall not have access to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>Other deal partners&apos; leads or clients</li>
                                <li>Sourcing tools, campaigns, or ATS features</li>
                                <li>Business development tools reserved for Business Partners and Team Leaders</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                7. Confidentiality
                            </h2>
                            <p className="text-slate-700 mb-4">
                                7.1 The Parties agree to keep all confidential information obtained during the course of
                                this Agreement strictly confidential and not to disclose it to any third party during or
                                after the term of this Agreement.
                            </p>
                            <p className="text-slate-700 mb-0">
                                7.2 These confidentiality obligations shall survive the termination of this Agreement
                                indefinitely for as long as the Confidential Information remains non-public or
                                proprietary in nature.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                8. Duration and Termination
                            </h2>
                            <p className="text-slate-700 mb-2">
                                This Agreement shall remain in effect until terminated by either Party.
                            </p>
                            <p className="text-slate-700 mb-2">
                                Either Party may terminate this Agreement at any time by providing written notice to the
                                other Party.
                            </p>
                            <p className="text-slate-700 mb-0">
                                Any commissions accrued prior to termination shall remain payable in accordance with the
                                conditions set forth in Section 5. “Accrued” means that all conditions necessary for
                                payment have been satisfied.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                9. Governing Law and Jurisdiction
                            </h2>
                            <p className="text-slate-700 mb-4">
                                This Agreement and any dispute, claim, or obligation arising out of or in connection
                                with it shall be governed by and construed in accordance with English law.
                            </p>
                            <p className="text-slate-700 mb-0">
                                The Parties irrevocably agree to submit to the exclusive jurisdiction of the English
                                courts.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                10. Miscellaneous
                            </h2>
                            <ul className="list-disc pl-6 text-slate-700 mb-4">
                                <li>
                                    The Deal Partner must promptly report to Cross Path any improper request or activity
                                    that could constitute bribery or corruption.
                                </li>
                                <li>
                                    Any amendment or modification to this Agreement must be made in writing and signed
                                    by both Parties.
                                </li>
                            </ul>
                            <p className="text-slate-700 mb-0">
                                IN WITNESS WHEREOF, the Parties have executed this Agreement as of the date first
                                written above.
                            </p>
                        </section>

                        {/* Signatures removed */}
                    </div>
                </div>
            </div>
        </Page>;
});
};
